export const getChildOutlineSectionsByIndex = (sections, index = 0) => {
  const original = sections[index];
  const foundSections = [];
  const sliced = sections.slice(index + 1);

  let i = 0;
  while (i < sliced.length && sliced[i].level > original?.level) {
    foundSections.push(sliced[i]);
    i += 1;
  }

  return foundSections;
};
